var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeStep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FA532E"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.576 14.981C17.2173 15.137 17.7243 15.475 18.097 15.995C18.4697 16.5063 18.656 17.1347 18.656 17.88C18.656 18.504 18.5217 19.0673 18.253 19.57C17.9843 20.0727 17.6117 20.467 17.135 20.753C16.6583 21.039 16.1253 21.182 15.536 21.182C14.886 21.182 14.327 21.052 13.859 20.792C13.391 20.5233 13.0487 20.1463 12.832 19.661C12.7367 19.4963 12.689 19.3317 12.689 19.167C12.689 18.9677 12.7453 18.7857 12.858 18.621C12.9793 18.4563 13.144 18.3437 13.352 18.283C13.4473 18.257 13.534 18.244 13.612 18.244C13.7593 18.244 13.9023 18.2787 14.041 18.348C14.1797 18.4173 14.2923 18.517 14.379 18.647C14.4657 18.8897 14.6087 19.0847 14.808 19.232C15.016 19.3707 15.2587 19.44 15.536 19.44C15.926 19.44 16.251 19.2883 16.511 18.985C16.7797 18.673 16.914 18.296 16.914 17.854C16.914 17.3947 16.7753 17.0263 16.498 16.749C16.2293 16.4717 15.8697 16.333 15.419 16.333H14.184C14.0973 16.333 14.0193 16.3027 13.95 16.242C13.8893 16.1813 13.859 16.1077 13.859 16.021C13.859 15.9517 13.8893 15.878 13.95 15.8L16.446 13.031H13.573C13.339 13.031 13.1353 12.9487 12.962 12.784C12.7973 12.6107 12.715 12.407 12.715 12.173V12.16C12.715 11.9173 12.7973 11.7137 12.962 11.549C13.1353 11.3843 13.339 11.302 13.573 11.302H17.213C17.5337 11.302 17.8023 11.4147 18.019 11.64C18.2443 11.8567 18.357 12.1253 18.357 12.446C18.357 12.6193 18.318 12.7883 18.24 12.953C18.162 13.109 18.0537 13.239 17.915 13.343L16.212 14.929L16.576 14.981Z",
    fill: "#FDF7F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_31",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2_31"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.32549 0 0 0 0 0.180392 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_31",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStep);
export default __webpack_public_path__ + "static/media/three-step.1d785e7448e881b9eb357d0c841da0a8.svg";
export { ForwardRef as ReactComponent };